export enum SurfacelogSignalSldStyle {
  H = 'H',
  DH = 'dH',
  PC = 'PC',
  NoLicence = 'noLicence',
  Default = 'Default',
  OutsideReferenceModel = 'OUTSIDE_REFERENCE_MODEL'
}